export const CLEAR_BOLTX_CART = 'CLEAR_BOLTX_CART';
export const SET_BOLTX_CART = 'SET_BOLTX_CART';
export const SET_BOLTX_SEARCH_RESULT = 'SET_BOLTX_SEARCH_RESULT';
export const UPDATE_BOLTX_SEARCH_RESULT = 'UPDATE_BOLTX_SEARCH_RESULT';
export const SET_BOLTX_OFFERS = 'SET_BOLTX_OFFERS';
export const SET_BOLTX_DEMO = 'SET_BOLTX_DEMO';
